import React, { useState, useEffect } from "react";
import { Button, TextField, Typography, Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { REDIRECT } from "../../services/actions";


export default function OrderRedirectPage() {
  const [orderId, setOrderId] = useState("");
  const [htmlBlobUrl, setHtmlBlobUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const dispatch = useDispatch();
  const redirectState = useSelector((state) => state.redirectState);

  const handleSubmit = () => {
    if (!orderId) {
      setError("Please enter an Order ID");
      return;
    }

    setError("");
    setLoading(true);
    setHtmlBlobUrl("");
    dispatch({
      type: `${REDIRECT}_GET`,
        payload: `redirect/${orderId}/`,
    });
  };
console.log("repost data",redirectState.data)
  useEffect(() => {
    if (redirectState?.data) {
      const htmlText = redirectState.data;
      try {
        const blob = new Blob([htmlText], { type: "text/html" });
        const url = URL.createObjectURL(blob);
        setHtmlBlobUrl(url);
      } catch (err) {
        setError("Failed to display the HTML content.");
      }
    }
    if (redirectState?.error) {
      setError("Failed to fetch order details.");
    }
    setLoading(false);
  }, [redirectState]);

  return (
    <Box p={3}>
      <Typography variant="h5" gutterBottom>
        Payment App - Repost
      </Typography>

      <Box display="flex" alignItems="center" gap={2} mb={2} flexWrap="wrap">
        <TextField
          label="Order ID"
          variant="outlined"
          value={orderId}
          onChange={(e) => setOrderId(e.target.value)}
          fullWidth
        />
        <Button                                                                                                               
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Loading..." : "Submit"}
        </Button>
      </Box>

      {error && (
        <Typography color="error" mb={2}>
          {error}
        </Typography>
      )}                                                                    

      {htmlBlobUrl && (
        <Box mt={3}>
          <Typography variant="h6">Result:</Typography>
          <iframe
            src={htmlBlobUrl}
            title="Order Result"
            style={{
              width: "100%",
              height: "600px",
              border: "1px solid #ccc",
              marginTop: "1rem",
            }}
            sandbox="allow-scripts allow-forms"
          />
        </Box>
      )}
    </Box>
  );
}
